import { useState, useEffect, useCallback } from 'react';

let _cache = null;
let _loading = false;
let _listeners = [];

function notify() {
  _listeners.forEach(fn => fn({ ..._cache }));
}

export default function useUser() {
  const [user, setUser] = useState(_cache);

  useEffect(() => {
    _listeners.push(setUser);
    return () => { _listeners = _listeners.filter(fn => fn !== setUser); };
  }, []);

  const load = useCallback(async () => {
    if (_loading) return;
    _loading = true;
    try {
      const r = await fetch('/api/auth/me');
      if (r.ok) {
        _cache = await r.json();
        notify();
      }
    } catch {}
    _loading = false;
  }, []);

  useEffect(() => {
    if (!_cache) load();
  }, [load]);

  const refresh = useCallback(async () => {
    _loading = false;
    _cache = null;
    await load();
  }, [load]);

  return { user: user || _cache, loading: !_cache && _loading, refresh };
}
